import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import { ContractInterface } from "../../Entity/Entities/Contract/ContractInterface";
import Constants from "../../Action/Constants";

class ContractUpdateWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const id = parseInt(this.component.props.params.id, 10);
    const contract: ContractInterface = this.component.props.app.contracts.filter((contract: ContractInterface) => contract.id === id)[0];

    if (!!contract) {
      return this.component.initializePage(contract);
    } else {
      this.component.props.dispatch({
        type: Constants.GLOBAL_CONTRACT_FOR_CONTRACT_DETAILS_PAGE,
        payload: {
          contractId: id,
        },
        onSuccess: (contract: ContractInterface) => {
          return this.component.initializePage(contract); 
        },
        onError: this.component.redirectBack
      });
    }
  }
}

export default new ContractUpdateWillMount();
